export default __webpack_public_path__ + "static/media/fontLato700_latin_ext.9c8812ea.woff2";